import { render, staticRenderFns } from "./upgradeButton.vue?vue&type=template&id=2b56ce9e&scoped=true&"
import script from "./upgradeButton.vue?vue&type=script&lang=js&"
export * from "./upgradeButton.vue?vue&type=script&lang=js&"
import style0 from "./less/upgradeButton.less?vue&type=style&index=0&id=2b56ce9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56ce9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b56ce9e')) {
      api.createRecord('2b56ce9e', component.options)
    } else {
      api.reload('2b56ce9e', component.options)
    }
    module.hot.accept("./upgradeButton.vue?vue&type=template&id=2b56ce9e&scoped=true&", function () {
      api.rerender('2b56ce9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/common/VueComponents/ugradeButton/upgradeButton.vue"
export default component.exports